const joinURLString = str => str.split(' ').join('-').toLowerCase().replace('?', '');
export default joinURLString